import { TFunction } from "i18next";
import { InferType, boolean, object, string } from "yup";




// const frPhoneRegex = /^[1-9]\d{8,10}$/;
const frPhoneRegex = /^\d{6,20}$/;


export const CollaborateurFormSchema = (t: TFunction) => {
  return object({
    //* Informations personnelles
    civilite: string().required(t("form.required")),
    nom: string().required(t("form.required")),
    prenom: string().required(t("form.required")),
    email: string()
      .email(t("form.invalidEmail"))
      .required(t("form.required")),
    phone: string()
      .matches(frPhoneRegex, t("form.invalidPhone"))
      .required(t("form.required")),
    fonction: string().required(t("form.required")),
    direction: string().required(t("form.required")),
    hasDroitImage: boolean().required(t("form.required")),
  })
};

export type CollaborateurFormSchemaType = InferType<
  ReturnType<typeof CollaborateurFormSchema>
>;

